import Icon from 'vue-awesome/components/Icon'

Icon.register({
  texture_sharp: {
    paths: [
      {
        d: 'M19.66 3L3.07 19.59V21h1.41L21.07 4.42V3zm-7.71 0l-8.88 8.88v2.83L14.78 3zM3.07 3v4l4-4zm18 18v-4l-4 4zm-8.88 0l8.88-8.88V9.29L9.36 21z'
      }
    ],
    width: '24',
    height: '24'
  }
})
